(() => {
  if (customElements.get('tenet-restock-review')) return;
  class TenetRestockReview extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.variants = JSON.parse(this.querySelector('[data-tenet-variants]').textContent);
      this.form = this.querySelector('[data-tenet-form]');
      this.replacement = this.querySelector('[data-tenet-replacement]');
      this.status = this.querySelector('[data-tenet-status]');
      this.scope = this.closest('.shopify-section') || document;
      this.form.addEventListener('submit', event => this.submit(event), options);
      document.addEventListener('variant:change', event => {
        if (!this.scope.contains(event.target)) return;
        this.render(event.detail?.variant?.id);
      }, options);
      this.scope.addEventListener('change', event => {
        if (event.target.closest('[data-tenet-form]')) return;
        requestAnimationFrame(() => this.isConnected && this.render());
      }, options);
      window.addEventListener('popstate', () => this.render(new URL(location.href).searchParams.get('variant')), options);
      this.render(this.dataset.selectedVariant);
    }
    disconnectedCallback() { this.events?.abort(); }
    selectedVariant(id) {
      const form = this.scope.querySelector('form[action*="/cart/add"]');
      const selected = String(id || form?.querySelector('[name="id"]')?.value || this.dataset.selectedVariant);
      return this.variants.find(variant => String(variant.id) === selected);
    }
    render(id) {
      const variant = this.selectedVariant(id);
      if (this.currentVariant?.id !== variant?.id) this.status.textContent = '';
      this.currentVariant = variant;
      const unavailable = variant && !variant.available;
      const replacement = unavailable && this.dataset.mode === 'replacement' && this.replacement.getAttribute('href');
      const notify = variant && (unavailable || variant.awaitingStock) && this.dataset.mode === 'notify';
      this.hidden = !(replacement || notify);
      this.replacement.hidden = !replacement;
      this.form.hidden = !notify;
    }
    async submit(event) {
      event.preventDefault();
      const variant = this.currentVariant;
      if (this.pending || !variant || (variant.available && !variant.awaitingStock) || this.dataset.mode !== 'notify' || !this.form.reportValidity()) return;
      this.pending = true;
      const button = this.form.querySelector('button[type="submit"]');
      button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Saving…';
      try {
        const fields = new FormData(this.form);
        const productUrl = new URL(this.dataset.productUrl);
        productUrl.searchParams.set('variant', variant.id);
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            email: String(fields.get('email') || '').trim(), website: fields.get('website'),
            productId: 'gid://shopify/Product/' + this.dataset.productId,
            variantId: 'gid://shopify/ProductVariant/' + variant.id,
            productTitle: this.dataset.productTitle, variantTitle: variant.title, sku: variant.sku,
            productUrl: productUrl.href, locale: document.documentElement.lang || 'en'
          })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'Unable to save your request. Please try again.');
        if (this.currentVariant?.id === variant.id) {
          this.status.textContent = payload.message || 'Your restock request has been saved.';
          this.form.reset();
        }
      } catch {
        if (this.currentVariant?.id === variant.id)
          this.status.textContent = 'Unable to save your request. Please try again.';
      } finally {
        this.pending = false;
        button.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('tenet-restock-review', TenetRestockReview);
})();
